module.exports = {

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

   data() {
       return {
           audit: this.data,
       }
   },

    methods:{
        fileUploadedEvent(){
            App.bus.$emit('auditable-file-uploaded')
        }
    },
}
